<template>
  <div class="mine-page">
    <div class="header-box">
      <img class="header" src="../../assets/images/mine/header.jpg" alt="">
      <div class="text">
        <p class="title">Careers</p>
        <p>和我们一起</p>
        <p>引领医疗数字化转型</p>
      </div>
    </div>
    <div class="mine-list">
      <div class="resume-content mine-flex">
        <p class="mine-flex"><img class="icon-resume" src="../../assets/images/mine/icon-myResume.png" alt="">我的简历</p>
        <a class="a-link" href="javascript:;" @click="go('/resume')">{{hasResume ? '编辑简历' : '添加简历' }}</a>
      </div>
      <ul class="my-jobs-list">
        <li class="mine-flex" @click="go('/mine/job_collect')">
          <p class="mine-flex"><icon-svg class="icon-item" name="mine-sc"></icon-svg>职位收藏</p>
          <icon-svg  class="icon-arrow"  name="icon-arrow"></icon-svg>
        </li>
        <li class="mine-flex" @click="go('/submit_record')">
          <p class="mine-flex"><icon-svg class="icon-item" name="mine-td"></icon-svg>投递记录</p>
          <icon-svg class="icon-arrow"  name="icon-arrow"></icon-svg>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import cookies from "@/libs/util.cookies";
import util from "../../libs/util";
export default {
  name: 'Mine',
  data(){
    return {
      hasResume:false,
      user_id:cookies.get('uid') || ''
    }
  },
  created() {
    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  mounted() {
    this.resumeDetail()
  },
  methods:{
    go(path){
      this.$router.push( { path: path} )
    },
    resumeDetail(){
      this.$api.RESUME_API_DETAIL({user_id:this.user_id}).then(res =>{
        if(res && res.id){
          this.hasResume = true
        }
      })
    },

  }
}
</script>

<style lang='scss' scoped>

  .header-box{
    position: relative;
    .text{
      position: absolute;
      top: 0;
      left: 0;
      text-align:left;
      color:#fff;
      padding-left:38px;
      padding-top:46px;
      overflow-x: hidden;
      p{
        margin:0;
        padding:0;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 28px;
      }
      p.title{
        font-size: 35px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 35px;
      }
    }
  }

  .header{
    width:100%;
    display:block;
  }

  .mine-list{
    padding:20px;
    border-radius: 20px 20px 0px 0px;
    background:#fff;
    position: relative;
    z-index:9;
    top:-20px;
  }

  .mine-flex{
    display:flex;
    align-items: center;
    justify-content: space-between;
  }

  .my-jobs-list{
    font-size:16px;
    color:#333;
    li{
      border-bottom:1px solid #F1F4F6;
    }
    p{
      margin:0;
      padding:14px 0;
    }
    .icon-item{
      width:21px;
      height:21px;
      margin-right:12px;
    }
    .icon-arrow{
      width:16px;
      height:16px;
    }
  }

  .resume-content{
    position: relative;
    padding:22px 20px;
    background:linear-gradient(90deg, #F5F8FF 0%, #ECF2FF 100%);
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 25px;
    margin-bottom:11px;
    .icon-resume{
      width:25px;
      height:23px;
      margin-right:8px;
    }
    p{
      margin:0;
    }
    a{
      width: 80px;
      height: 30px;
      background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
      border-radius: 26px;
      color: #FFFFFF;
      font-size:12px;
      line-height: 30px;
      position: relative;
      z-index:99;
    }
  }

  .resume-content::after{
    display:block;
    content:'';
    width:135px;
    height:100%;
    background:url(../../assets/images/mine/bg.png) no-repeat;
    background-size:100% 100%;
    position: absolute;
    top:0;
    right:25px;
  }

</style>
